import { useTranslation } from 'react-i18next';

import { useNavigate, useNavigation } from 'hooks';

type useBreadcrumbReturn = {
  navigationLabel: () => string;
  handleNavigateClick: () => void;
};

export const useBreadcrumb = (location: string): useBreadcrumbReturn => {
  const { t } = useTranslation('breadcrumb');
  const {
    navigateToDashboard,
    navigateToSummary,
    navigateToResponse,
    navigateToReports,
    navigateToManageConsultees,
  } = useNavigate();
  const {
    consultationId,
    isReportsPage,
    isReportPage,
    isSummaryPage,
    isResponsePage,
    isArchivedResponsePage,
    isCaseDetailsPage,
    isManageTeamPage,
    isCreateOrganisationPage,
    isManageOrganisationPage,
  } = useNavigation(location);

  const navigationLabel = (): string => {
    if (isSummaryPage || isReportsPage || isManageTeamPage) {
      return t('dashboard', 'Dashboard');
    }
    if (isResponsePage || isCaseDetailsPage) {
      return t('summary', 'Summary');
    }
    if (isArchivedResponsePage) {
      return t('response', 'Response');
    }
    if (isReportPage) {
      return t('reports', 'Report selection');
    }
    if (isCreateOrganisationPage || isManageOrganisationPage) {
      return t('manage_consultees', 'Manage consultees');
    }
    return '';
  };

  const handleNavigateClick = () => {
    if (isSummaryPage || isReportsPage || isManageTeamPage) {
      return navigateToDashboard();
    }
    if ((isResponsePage || isCaseDetailsPage) && consultationId) {
      return navigateToSummary(consultationId);
    }
    if (isArchivedResponsePage && consultationId) {
      return navigateToResponse(consultationId);
    }
    if (isReportPage) {
      return navigateToReports();
    }
    if (isCreateOrganisationPage || isManageOrganisationPage) {
      return navigateToManageConsultees();
    }
  };

  return {
    navigationLabel,
    handleNavigateClick,
  };
};
